import React, { useEffect } from "react";
import {
  MapPinIcon,
  PhoneIcon,
  EnvelopeIcon,
  HomeIcon,
} from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";

function Contact() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="max-w-screen-lg mx-auto px-4 py-10">
      {/* Breadcrumb */}
      <nav className="flex text-sm text-gray-500 mb-6" aria-label="Breadcrumb">
        <ol className="inline-flex items-center space-x-1 md:space-x-2">
          <li className="inline-flex items-center">
            <Link
              to="/"
              className="inline-flex items-center hover:text-blue-600 font-medium"
            >
              <HomeIcon className="w-4 h-4 mr-2 text-gray-400" />
              Trang chủ
            </Link>
          </li>
          <li>
            <div className="flex items-center">
              <svg
                className="w-3 h-3 mx-2 text-gray-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M7.05 4.05a.75.75 0 011.06 0l5.25 5.25a.75.75 0 010 1.06l-5.25 5.25a.75.75 0 11-1.06-1.06L11.19 10 7.05 5.91a.75.75 0 010-1.06z" />
              </svg>
              <span className="ml-1 font-medium text-gray-400">Liên hệ</span>
            </div>
          </li>
        </ol>
      </nav>

      {/* Thông tin liên hệ */}
      <section className="text-center mb-10">
        <h1 className="text-3xl font-bold text-primary mb-2">
          Liên hệ với chúng tôi
        </h1>
        <p className="text-gray-600 mb-6">
          Mọi thông tin chi tiết & nhận tư vấn cụ thể hơn xin quý khách vui lòng
          liên hệ trực tiếp:
        </p>

        <h2 className="text-xl font-semibold text-primary mb-6">
          CCA - Hội Xây Dựng Thành phố Cần Thơ
        </h2>

        {/* Email + SĐT cùng dòng */}
        <div className="flex flex-col items-center space-y-2 text-gray-800 text-center">
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2">
            <div className="flex items-center gap-1">
              <PhoneIcon className="w-5 h-5 text-primary" />
              <span className="font-medium">Điện thoại:</span>
              <a
                href="tel:0907070359"
                className="text-blue-600 hover:underline ml-1"
              >
                 0907070359
              </a>
            </div>

            <div className="flex items-center gap-1">
              <EnvelopeIcon className="w-5 h-5 text-primary" />
              <span className="font-medium">Email:</span>
              <a
                href="mailto:hoixaydung.tpcantho@gmail.com"
                className="text-blue-600 hover:underline ml-1"
              >
                hoixaydung.tpcantho@gmail.com
              </a>
            </div>
          </div>

          {/* Địa chỉ riêng dòng dưới */}
          <div className="flex justify-center items-center gap-2">
            <MapPinIcon className="w-5 h-5 text-primary" />
            <span className="font-medium">Địa chỉ:</span>
            <span>59 Hùng Vương, P. Ninh Kiều, Tp. Cần Thơ</span>
          </div>
        </div>
      </section>

      {/* Google Map */}
      <section className="w-full h-[400px] rounded-lg overflow-hidden">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d20298.14629827564!2d105.77403200000002!3d10.04378!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31a08900504eeb83%3A0xce1f6cb67b0c1560!2zSOG7mWkgWMOieSBE4buxbmcgVHAuIEPhuqduIFRoxqE!5e1!3m2!1sen!2sus!4v1778809597617!5m2!1sen!2sus"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          allowFullScreen=""
          title="Google Map CCA"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </section>
    </div>
  );
}

export default Contact;
